import axios from "axios";

export const fetchDataMixin = {
  data() {
    return {
      data: null,
      loading: false,
      error: null,
    };
  },
  methods: {
    fetchData(url, options = {}) {
      this.loading = true;
      axios
        .get(url, options)
        .then((response) => {
          this.data = response.data.Data;
          // Handle other success logic if needed
          if (response.status === 200) {           
            this.loading = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.error = error.message;
          // Handle error logic if needed
          setTimeout(() => {
            this.error = null;
          }, 1500);
        });
    },
  },
};
